export const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT ?? '{}.VITE_ENVIRONMENT',
  SUPABASE_PROJECT_ID: import.meta.env.VITE_SUPABASE_PROJECT_ID ?? '{}.VITE_SUPABASE_PROJECT_ID',
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL ?? '{}.VITE_SUPABASE_URL',
  SUPABASE_PUBLISHABLE_KEY:
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '{}.VITE_SUPABASE_PUBLISHABLE_KEY',
  GA_TRACKING_ID: import.meta.env.VITE_GA_TRACKING_ID ?? '{}.VITE_GA_TRACKING_ID',
};
